import React from 'react';
import ProtectedRoute from '../protected';
import Dashboard from '../../pages/payroll-section/dashboard';
import PayrollReports from '../../pages/reports/payroll-reports';

export const PayrollDashboardRoutes = [
  <ProtectedRoute exact path='/dashboard' component={Dashboard} />,
  <ProtectedRoute exact path='/payroll-reports' component={PayrollReports} />,
]